import { connect } from "react-redux";
import Toolbar from "../components/Outputs/Toolbar";
import { selectUrl } from "../actions/outputs";

const mapStateToProps = state => {
  return {
    title: "Outputs",
    config: state.outputs.toolbar,
    selected: state.outputs.selectedUrl
  };
};

const mapDispatchToProps = dispatch => {
  return {
    selectItem: url => dispatch(selectUrl(url))
  };
};

const OutputsToolbar = connect(mapStateToProps, mapDispatchToProps)(Toolbar);

export default OutputsToolbar;
